module.exports = __webpack_public_path__ + "static/images/icon-imperial.3f0b8a2ee4f7c0085f3fd53ace986e6a.svg";